// External
import React from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { bool, object, func } from 'prop-types';
import { Formik } from 'formik';
import { Box, Flex } from 'rebass';
import { ButtonStyled, DropDownStyled, Grid, GridItem, TextFieldStyled } from '@nike/nike-design-system-components';
import { CaretLeft } from '@nike/nike-design-system-icons';

// Components
import Page from '../common/Page';

// Functions
import { getPendingStatus } from '../../util/requestReducer';
import { createCatalogType } from './actions';

// Constants
import { ERROR_MESSAGES, GRID_EXTERIOR_GAP, validationSchema } from './constants';
import { SALES_ORGS } from '../catalogs/constants';

import { StepBox } from '../../styles/styles';

const CreateCatalogType = ({ createCatalogType, isSaving }) => {
  const history = useHistory();
  const handleSave = async values => {
    const catalogTypeData = {
      name: values.name.toUpperCase(),
      salesOrg: values.salesOrg
    };

    const newCatalogTypeId = await createCatalogType(catalogTypeData);

    return history.push(`/catalogTypes/edit/${newCatalogTypeId}`);
  };

  const body = () => {
    return (
      <Box p='20px'>
        <Grid rowGapXs='12px' {...GRID_EXTERIOR_GAP}>
          <GridItem xs={4}>
            <Formik
              initialValues={{ name: '', salesOrg: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSave}
            >
              {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                <form onSubmit={handleSubmit}>
                  <StepBox>Catalog Type</StepBox>
                  <TextFieldStyled
                    id='name'
                    error={errors.name && touched.name}
                    errorMessage={ERROR_MESSAGES.name}
                    label='Name'
                    name='name'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                  />

                  <Box mt='12px'>
                    <StepBox>Sales Organization</StepBox>
                    <DropDownStyled
                      id='salesOrg'
                      error={errors.salesOrg && touched.salesOrg}
                      errorMessage={ERROR_MESSAGES.salesOrg}
                      label='Select Sales Organization'
                      name='salesOrg'
                      onChange={handleChange}
                      options={SALES_ORGS}
                      value={values.salesOrg}
                    />
                  </Box>

                  <Flex flexWrap='wrap' justifyContent='flex-end' mt='12px'>
                    <ButtonStyled className='ml4-sm' disabled={isSubmitting} type='submit'>
                      Create
                    </ButtonStyled>
                  </Flex>

                  {isSaving && <Box mt='8px'>Saving...</Box>}
                </form>
              )}
            </Formik>
          </GridItem>
        </Grid>
      </Box>
    );
  };

  return (
    <Page
      title='Create Catalog Type'
      HeaderContent={
        <Box mt='8px' mb='20px'>
          <Link to='/catalogTypes'>
            <ButtonStyled type='button' appearance='text' background='light' size='large'>
              <CaretLeft size='s' />
              <span className='ml1-sm'>Back to Catalog Types</span>
            </ButtonStyled>
          </Link>
        </Box>
      }
    >
      {body()}
    </Page>
  );
};

CreateCatalogType.propTypes = {
  createCatalogType: func.isRequired,
  history: object,
  isSaving: bool.isRequired
};

CreateCatalogType.defaultProps = {
  history: { push: () => {} }
};

const mapStateToProps = state => {
  return {
    isSaving: getPendingStatus(state, [createCatalogType.event.name])
  };
};

const mapDispatchToProps = {
  createCatalogType
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCatalogType);
